/**
 * Grail27 — compact add feedback during AJAX add. Visual only (never blocks clicks).
 */
(function () {
  if (window.__grailCartAddOverlayBound) return;
  window.__grailCartAddOverlayBound = true;

  var overlay;
  var messageEl;
  var hideTimer;
  var safetyTimer;

  var TEXT_ADDING = 'Adding to your cart…';
  var TEXT_ADDED = 'Added to cart';
  var SUCCESS_MS = 320;
  var SAFETY_MS = 8000;

  function clearTimers() {
    window.clearTimeout(hideTimer);
    window.clearTimeout(safetyTimer);
  }

  function hideOverlay() {
    if (!overlay) return;
    clearTimers();
    overlay.classList.remove('is-visible', 'is-success');
    overlay.setAttribute('aria-hidden', 'true');
    if (messageEl) messageEl.textContent = TEXT_ADDING;
  }

  function exposeUi() {
    window.GrailCartUi = window.GrailCartUi || {};
    window.GrailCartUi.hideOverlay = hideOverlay;
  }

  function showAdding() {
    if (!overlay || !messageEl) return;
    clearTimers();
    overlay.classList.remove('is-success');
    overlay.classList.add('is-visible');
    overlay.setAttribute('aria-hidden', 'false');
    messageEl.textContent = TEXT_ADDING;

    safetyTimer = window.setTimeout(hideOverlay, SAFETY_MS);
  }

  function showSuccessAndScheduleHide() {
    if (!overlay || !messageEl || !overlay.classList.contains('is-visible')) return;

    clearTimers();
    messageEl.textContent = TEXT_ADDED;
    overlay.classList.add('is-success');
    hideTimer = window.setTimeout(hideOverlay, SUCCESS_MS);
  }

  function isProductFormEvent(event) {
    return !!(event && event.source === 'product-form');
  }

  function getAddToCartButton(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest(
      '.grail-card-quick-cart__btn, .grail-atc-btn, .product-form__submit[name="add"], [type="submit"][name="add"]'
    );
    if (!btn) return null;
    var form = btn.closest('form[data-type="add-to-cart-form"]');
    if (!form || !form.closest('product-form')) return null;
    if (btn.hasAttribute('disabled')) return null;
    if (btn.getAttribute('aria-disabled') === 'true') return null;
    return btn;
  }

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.dataset.type !== 'add-to-cart-form') return false;
    if (!form.closest('product-form')) return false;

    return !!getAddToCartButton(form.querySelector('[type="submit"][name="add"], [type="submit"]'));
  }

  function primeButtonFeedback(btn) {
    if (!btn) return;
    btn.classList.add('is-adding');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  function clearButtonFeedback(btn) {
    if (!btn) return;
    btn.classList.remove('is-adding');
    var spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!isProductFormEvent(event)) return;
      showSuccessAndScheduleHide();
      if (window.__grailActiveAddButton) {
        clearButtonFeedback(window.__grailActiveAddButton);
        window.__grailActiveAddButton = null;
      }
    });

    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (!isProductFormEvent(event)) return;
      hideOverlay();
      if (window.__grailActiveAddButton) {
        clearButtonFeedback(window.__grailActiveAddButton);
        window.__grailActiveAddButton = null;
      }
    });
  }

  function init() {
    overlay = document.getElementById('grail-cart-add-overlay');
    messageEl = document.getElementById('grail-cart-add-overlay-text');
    exposeUi();
    if (!overlay || !messageEl) return;

    document.addEventListener(
      'pointerdown',
      function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        var btn = getAddToCartButton(event.target);
        if (!btn) return;
        window.__grailActiveAddButton = btn;
        primeButtonFeedback(btn);
      },
      { passive: true, capture: true }
    );

    document.addEventListener(
      'submit',
      function (event) {
        if (!isAddToCartForm(event.target)) return;
        showAdding();
      },
      true
    );

    bindPubSub();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
